var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config.order_feature == 1)?_c('order-item-list'):(_vm.config.order_feature == 0)?_c('div',[_c('vx-card',[_c('h2',[_vm._v("This is for Go Check In full version, please contact us for more info at "),_c('b',[_vm._v("832-968-6668")])])])],1):_c('custom-spinner')
}
var staticRenderFns = []

export { render, staticRenderFns }